
import React, { useContext, useEffect, useState } from "react";
import CircularScrollProgress from "../Circularprogress";
import { useNavigate } from "react-router-dom";
import AuthUser from "../../services/AuthUser";
import { handleRazorpayPayment } from "../../services/handlePayment";
import { ServicesContext } from "../../services/ServicesContext";
import CitySelector from "../User/CitySelectore";
import WhatsAppScrollButton from "../floatingwhatsApp";
import Footer from "../footer";
import { PartenerSheepDeedService } from "../../services/parternshipservice";
import HomeCounters from "../Homecounters";
import Testimonials from "../Testimonial";

function TrustAndSociety() {

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);


  const [activeQuestion, setActiveQuestion] = useState(null);
  const { http, token } = AuthUser();
  const navigate = useNavigate();
  const toggleQuestion = (questionId) => {
    setActiveQuestion((prev) => (prev === questionId ? null : questionId));
  };


  const [newData, setNewData] = useState({ user_name: '', user_email: '', user_contact: '', user_city: '' })
  const [errors, setErrors] = useState({});
  const { services, loading, error } = useContext(ServicesContext);
  //   if (loading) {
  //      return <div>Loading...</div>;  // Show loading state while fetching data
  //  }

  //  if (error) {
  //      return <div>{error}</div>;  // Show error state if there was an issue fetching data
  //  }
  const service = services.find(s => s.service_id === 49);

  const validateForm = () => {
    const newErrors = {};

    // Name validation
    if (!newData.user_name.trim()) {
      newErrors.user_name = 'Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }

    // Email validation
    if (!newData.user_email.trim()) {
      newErrors.user_email = 'Email address is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

    // Phone number validation
    // if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
    //    newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    // }

    if (!newData.user_contact.trim()) {
      newErrors.user_contact = 'number is required.';
    } else if (!/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }


    // City validation
    if (!newData.user_city) {
      newErrors.user_city = 'City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Returns true if no errors
  };


  const formPutPartenshipdeed = async (e) => {
    e.preventDefault();
    // ✅ Check if user is logged in
    // if (!token) {
    //   alert("Please log in to continue.");
    //   localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
    //   navigate('/login'); // 👈 Use this if you're using React Router
    //   return;
    // }

    if (!validateForm()) return;

      localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });

       // ✅ RESET FORM (SAFE)
  setNewData({
    user_name: '',
    user_email: '',
    user_contact: '',
    user_city: ''
  });
  };


  
      //   const formPutPartenshipdeed = async (e) => {
      //     e.preventDefault();
      
      //     if (!validateForm()) return;
      
      //     try {
      //         const response = await PartenerSheepDeedService.societyForm(newData);
      
      //         console.log("API Success:", response);
      
      //         navigate("/thankyou");
      
      //         // Optional: reset form
//               setNewData(prev => {
//   const resetObj = {};
//   Object.keys(prev).forEach(key => (resetObj[key] = ""));
//   return resetObj;
// });
    
      
      //     } catch (error) {
      //         console.error("API Error:", error);
      //         alert("Something went wrong!");
      //     }
      // };

  const faqList = [
  {
    question: "What is a Society?",
    answer: "A society refers to a group of individuals who unite with a shared objective or purpose, often centered around promoting charitable, literary, scientific, or social causes."
  },
  {
    question: "Is a Society a Legal Entity?",
    answer: "Yes, once registered under the applicable laws, a society is recognized as a legal entity. This allows it to own property, enter into contracts, and initiate legal proceedings in its name."
  },
  {
    question: "Why is Society Registration Important?",
    answer: "Registering a society gives it legal recognition, builds trust among stakeholders, allows access to government schemes or grants, and ensures smoother governance and dispute resolution."
  },
  {
    question: "How Many Members Are Required to Form a Society in India?",
    answer: "A minimum of seven members is required to register a society in India. These individuals can be Indian citizens, and in some states, even foreign nationals are permitted."
  },
  {
    question: "Does a Change in Membership End the Society?",
    answer: "No, a society does not dissolve due to a change in its membership. It continues to operate as long as it complies with legal and constitutional requirements."
  },
  {
    question: "Who Can Register a Society?",
    answer: "The following are eligible to form and register a society in India:\n\n- Individuals\n- Companies\n- Partnership Firms\n- Foreign nationals\n- Registered societies"
  },
  {
    question: "How Can I Change the Name of My Society?",
    answer: "To change your society’s name, a resolution must be passed by the General Body. After that, you must apply for name change approval from the Registrar of Societies along with the necessary documentation."
  },
  {
    question: "Can Relatives Be Members of a Society?",
    answer: "Yes, relatives are eligible to become members of a society, provided the society’s rules and regulations allow it."
  },
  {
    question: "What Is the General Body of a Society?",
    answer: "The General Body consists of all the members of the society. It holds the authority to make key decisions, approve budgets, amend rules, and oversee the society’s activities."
  },
  {
    question: "What Are the Components of a Society’s MOA (Memorandum of Association)?",
    answer: "The MOA of a society typically includes:\n\n- Name of the Society\n- Registered office address\n- Aims and objectives\n- Names and addresses of founding members\n- Rules and regulations governing the society"
  }
];


const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};



  return (
    <div>


      <div className="hero-area10 header-background">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              <div className="title title2  ">
                <div className="headding-shape aniamtion-key-2">
                  <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                </div>
                <h1 className="sk-text-color">Online Society Registration</h1>
                <p className="pdrl-text">Get Online Society Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Govt. Fees As per actual Extra)</span></p>
                <p className="pd-text">Start your society with the trusted support of Dm2Legal and continue your mission of meaningful education or charitable outreach for a greater good!</p>
                <p className="pd-text">If you're a group of individuals uniting around a shared passion—whether it's art, culture, science, or philanthropy—now is the perfect time to register your society (SOCR). Build a community of like-minded people and contribute to making the world a better place.</p>
                               <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div>
              </div>
            </div>
            <div className="col-lg-4">
              <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
              <div className="contact3-form-all">
                <div className="hadding7">
                  <h3>Book Service Now </h3>
                  <p className="pdrl-text">at Rs.{service?.price}/- Only <span><br />(Govt. Fees As per actual Extra)</span></p>
                </div>
                <form action="#">
                  <div className="form-input-all">
                    <div className="form-input-box">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label htmlFor="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                              <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label htmlFor="">Email Address<span className="red">*</span></label>{errors.user_email && <p className="error-text">{errors.user_email}</p>}
                              <input type="email" placeholder="Enter your Email Address" value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="input-single6">
                            <div className="">
                              <label htmlFor="">Contact Number<span className="red">*</span></label> {errors.user_contact && <p className="error-text">{errors.user_contact}</p>}
                              <input type="number" placeholder="Enter your Contact Number" value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <CitySelector
                            newData={newData}
                            setNewData={setNewData}
                            fieldKey="user_city"
                            errors={errors}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="space20"></div>
                    <div className="btn-group-2">
                      <a className="theme-btn-3" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space60 bg-white"></div>

      <div className="home4-counters bg-white">
        <div className="container">

          <div className="row">
            <div className="col-md-12">


              <HomeCounters />
            </div>
          </div>


          <div className="space40"></div>
          <div className="row">
            <div className="col-lg-12">
              <p className="pd-text">A society is a non-profit organization formed by a group of individuals united for a common purpose—often to support charitable, cultural, religious, educational, or artistic causes. In India, the registration of societies is governed by the Societies Registration Act of 1860, which has been adopted and customized by various state governments.

                Not just Indian nationals, but also foreigners, companies, and other registered entities are eligible to register a society under the Memorandum of Association (MOA). Registering a society ensures compliance with the rules and regulations laid down by the respective state authorities and provides legal recognition to your organization.

                If you're planning to register a society and need expert guidance, Dm2Legal is here to help. Our legal experts will handle the entire registration process smoothly and efficiently—so you can focus on your mission.

                Get in touch with Dm2Legal today and take the first step towards building a legally recognized society.</p>


            </div>
          </div>

          <div className="space20"></div>

        </div>
      </div>


      <div className="service-binifits9 bg-white" >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">How to apply</h2>
                <div className="space20"></div>
                <img src="assets/new/Trust-Society-Registration.png" />
              </div>
              <div className="space20"></div>
            </div>
          </div>
        </div>
      </div>
      <div className="space20 bg-white"></div>


      <div className="service-binifits9 sp0" id="service2" >
        <div className="space40"></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <h2 className="text-center">Benefits of Online Society Registration with Dm2Legal</h2>
                <div className="service-binifits-boxs">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Legal Recognition and Separate Entity</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Property Rights</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Help in Legal Proceedings</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Tax Exemption</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Fund Accumulation</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="single-boxs">
                        &nbsp;&nbsp;
                        <div className="icon">
                          <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                            Member Liability</p>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="space30"></div>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">




          <div className="row">
            <div className="col-lg-12">
              <div className="hadding7">
                <div className="space40"></div>
                <h2 className="text-center">Understanding Society Registration Renewal Process</h2>
                <div className="space40"></div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="contact6-list doc-list">
                <p className="pd-text">Every society registered in India must renew its registration certificate every five years. At Dm2Legal, we simplify this renewal process for you in just a few easy steps:</p>

                <ul>
                  <li className="font-f-7 ">
                    <div className="step-font-size"> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Step 1: Submit the Renewal Application</div>
                    <div className="space10"></div>
                    <p className="pd-text">Begin by submitting a renewal application along with the updated list of the current governing body members.</p>
                  </li>
                  <hr />
                  <li className="font-f-7">
                    <div className="step-font-size">
                      <span>
                        <img className="arow" src="assets/image/arow-01.svg" alt="" />
                      </span>{" "}
                      Step 2: Fill Out the Online Renewal Form
                    </div>
                    <div className="space10"></div>
                    <p className="pd-text">Provide the following details in the online application:</p>
                    <ul className="pd-text" style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                      <li><strong>Registration Number</strong> – The society’s existing registration number.</li>
                      <li><strong>Identity Proof</strong> – Valid identity documents of all individuals involved.</li>
                      <li><strong>Supporting Documents</strong> – Contact information and any other relevant documents.</li>
                    </ul>
                  </li>

                  <hr />
                  <li className="font-f-7">
                    <div className="step-font-size">   <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 3:  Receive Confirmation</div>
                    <div className="space10"></div>
                    <p className="pd-text">Once all required documents are submitted, your society’s registration will be successfully renewed. The original registration number will remain unchanged.</p>
                  </li>



                </ul>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="space30"></div>
              <img src="assets/img/images/Trademark-Registration-Step-by-Step-Guide-.png" alt="" />
            </div>
          </div>


        </div>
      </div>

      <div className="service-binifits9 sp0" id="service2">
        <div className="container work8">
          <div className="row">
            <div className="col-lg-12 text-center">
              <div className="hadding7">
                <div className="space80"></div>
                <h2 className="text-center">Society Act Registration Online: Simplified Process</h2>
              </div>
              <div className="partnership-deade-section">
                <div className="space40"></div>

                <ul className="disc-list">
                  <li><h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>At Dm2Legal, our experts review your documents for accuracy to streamline the registration process.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Our top-tier experts in Firm and Society registration are ready to assist you with all necessary documentation and licensing requirements.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Once your documents are reviewed, our assigned professional will proceed with the Society Registration application on your behalf.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                    <span>Upon successful submission, you’ll receive the Application ID, Transaction ID, and Challan Reference ID from us to track the progress.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                  <li><h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                    <span>Please wait for our expert to contact you with updates regarding your Society Registration status.</span>
                    <svg className="pointer">
                      <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                    </svg>
                  </li>
                </ul>

                <div className="space80"></div>
              </div>
            </div>
          </div>


        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="hadding7">
              <div className="space40"></div>
              <h2 className="text-center">Common Mistakes to Avoid in Society Registration</h2>
              <div className="space20"></div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="contact6-list doc-list" style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', height: '100%' }}>
              <ul>
                <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Inadequate Research and Planning</li>
                <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Neglecting Legal Compliance</li>
                <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Lack of Clear Objectives and Focus</li>
                <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Poor Financial Planning</li>
                <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Inadequate Documentation and Record-Keeping</li>
                <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Incorrect Selection of Organisational Structure</li>
                <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Overlooking Stakeholder Involvement</li>
                <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Ignoring Marketing and Outreach</li>


              </ul>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="contact6-list doc-list">
              <img src="assets/img/images/Common-Mistakes-to-Avoid-in-IEC-Registration.png" alt="" />
            </div>
          </div>



        </div>
      </div>


      <div className="bg-white">

        <div className="container ">


          <div className="row">
            <div className="col-12">
              <div className="faq-items" id="masonry-grid">
                <div className="mesonry-item general single-price-list">
                  <div className="faqs inner-faq">
                    <h2 className="text-center">Trademark Registration: FAQs and Common Queries</h2>
                    <div className="space30"></div>


                    <div id="general">


                   {faqList.map((faq, index) => (
                        <div className="single-faq" key={index}>
                          <h2
                            className={`faq-heading font-f-3 weight-700 ${activeQuestion === index ? '' : 'collapsed'}`}
                            id={`faq-heading${index}`}
                            onClick={() => toggleQuestion(index)}
                          >
                            Q{index + 1}: {faq.question}
                            <span>
                              {activeQuestion === index ? (
                                <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="collapse icon" />
                              ) : (
                                <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="expand icon" />
                              )}
                            </span>
                          </h2>
                          <div
                            id={`collapse${index}`}
                            className={`accordion-collapse collapse ${activeQuestion === index ? 'show' : ''}`}
                          >
                            <p className="font-f-3 weight-500">{faq.answer}</p>
                          </div>
                        </div>
                      ))}










                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>




      <Testimonials />

      <div className="sp2 last-section bg-white">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 m-auto text-center">
              <div className="hadding7">

                <h2>Why Choose Dm2Legal for Society Registration?</h2>
              </div>
            </div>
          </div>
          <div className="space30"></div>
          <div className="row">
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>1</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="#" >Hassle-Free Society Registration</a></h4>
                  <p>With Dm2Legal, registering your society is quick and simple. Just fill in your name, email ID, and contact number, then select our Society Registration service. Once you've submitted your request, our team will promptly reach out to guide you through the next steps.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6" >
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>2</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Trusted Online Platform</a></h4>
                  <p>Dm2Legal is proud to be one of India’s most trusted online platforms for Society Registration. No matter where you're located, we’re equipped to serve you entirely online—efficiently and reliably.
</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>3</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Dedicated Customer Support</a></h4>
                  <p>Our team at Dm2Legal is known for responsive and friendly customer support. We’re here to assist you not only during the registration process but even after your registration is complete. Your feedback is always welcomed and valued.
</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>4</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >A Decade of Expertise</a></h4>
                  <p>Backed by 10+ years of industry experience, Dm2Legal has the knowledge and expertise to ensure a seamless Society Registration experience. Our professionals are well-versed in the entire process, offering you peace of mind from start to finish.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>5</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" > Timely Service Delivery</a></h4>
                  <p>Time is valuable, and at Dm2Legal, we respect that. As soon as we receive your request, our team begins working on your case without delay, ensuring prompt service at every step.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="service6-box">
                <div className="">
                  <div className="service-box-icon">
                    <p>6</p>
                  </div>
                </div>
                <div className="hadding6">
                  <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Affordable & Transparent Pricing</a></h4>
                  <p>Our services are budget-friendly without sacrificing quality. At Dm2Legal, we prioritize your satisfaction and ensure every rupee you invest brings maximum value.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="space40 bg-white"></div>

      <WhatsAppScrollButton />
      <Footer />
      <CircularScrollProgress />

    </div>

  );
}
export default TrustAndSociety;